<template>
  <!--  -->
  <div :key="img+''+color" class="sp-pic">
    <img :src="img">
    <div 
      class="color-mask"
      :style="style_mask"
    ></div>
  </div>
</template>

<script>

export default {
  name: '',
  components: {},
  props: [
    'img',
    'color',
  ],
  data() {
    return {
      style_mask: '',
    }
  },
  computed: {},
  watch: {},
  methods: {
    run(){
      let v = this
      v.style_mask = `background-color: ${v.color || 'transparent'};-webkit-mask-image: url(${v.img});`
      // setTimeout(() => {
      // }, 100);
    },
  },
  created() {
    // this.run()
    return
  },
  mounted() {
    this.run()
  },
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .sp-pic{
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    .color-mask{
      position: absolute;
      top: 0;
      width: 100%;
      background-position: top center;
      background-size: 100% auto;
      height: 100%;
      mix-blend-mode: overlay;
      mask-size: cover;
      opacity: 0.8;
    }
  }
</style>